import { PROMOTION } from '../../constants/constant_doc_types';
import * as apiCommon from '../apiCommon';
import * as apiUtil from '../apiUtils';
import { getLocalDatetime } from '../../utils/local_date';

export const fetchPromotionById = (app, params) => {
  const { id } = params;
  const docType = PROMOTION;
  return apiCommon.getDoc(app, { id, docType }, { assemble_custom_fields: true });
};

export const savePromotion = (app, params) => {
  const { data } = params;

  const promotionData = {
    doc_type: PROMOTION,
    name: data.name,
    short_name: data.short_name,
    available_from: getLocalDatetime(data.available_from),
    available_to: getLocalDatetime(data.available_to),
    item_id: data.item_id,
    is_manual: apiUtil.toBoolean(data.is_manual),
    is_markdown: apiUtil.toBoolean(data.is_markdown),
    promotion_type_id: data.promotion_type_id,
    authorised_by_id: data.authorised_by_id,
    price_levels: apiUtil.toObjectIds(
      data.price_levels,
      data.price_level_ids,
      'price_level_id'
    ),
    excluded_locations: apiUtil.toObjectIds(
      data.excluded_locations,
      data.excluded_location_ids,
      'location_id',
    ),
    product_promotion: data.product_promotion,
    value_promotion: data.value_promotion,
    active: apiUtil.toBoolean(data.active),
    apply_reward_to_trigger: apiUtil.toBoolean(data.apply_reward_to_trigger),
    exclude_uom: apiUtil.toBoolean(data.exclude_uom),
    loyalty_multiplier: apiUtil.toDecimal(data.loyalty_multiplier),
    exempts: data.exempts,
    weekly_schedules: (data.weekly_schedules || []).map((weeklySchedule) => {
      const { start_hour, start_minute, end_hour, end_minute } = weeklySchedule;
      weeklySchedule.start_time = `${start_hour}:${start_minute}`;
      weeklySchedule.end_time = `${end_hour}:${end_minute}`;
      return weeklySchedule;
    }),
  };

  ((promotionData.value_promotion || {}).impact || []).forEach((impact) => {
    delete impact.onEditMode;
  });

  ((promotionData.product_promotion || {}).criteria || []).forEach(
    (criteria) => {
      criteria.quantity = apiUtil.toDecimal(criteria.quantity);
      criteria.max_quantity = apiUtil.toDecimal(criteria.max_quantity);
    },
  );

  const dataParams = {
    source: data,
    doc: promotionData,
  };
  console.log('promotionData', promotionData);
  return apiCommon.saveDoc(app, dataParams);
};

export const deletePromotion = (app, params) => {
  const { id } = params;
  return apiCommon.deleteDoc(app, { id, docType: PROMOTION });
};

export function fetchPromotionDropdown(app, params) {
  const { searchTerm, searchParams, fields, id } = params;
  const query = {
    id,
    fields,
    searchTerm,
    searchParams,
    dropdown_type: 'promotion/dropdown',
  };
  return apiCommon.getDropdownList(app, { query });
}

export function fetchPromotionTypeDropdown(app, params) {
  const { searchTerm, searchParams, fields, id } = params;
  const dropdown_type = 'promotion_type/dropdown';
  const query = {
    id,
    dropdown_type,
    fields,
    searchTerm,
    searchParams,
  };
  return apiCommon.getDropdownList(app, { query });
}
